module.exports = __webpack_public_path__ + "img/google-play.c5f73060.svg";